import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  IvSignService,
} from '../../../../api';
import { UserService } from '../../../../api/api/user.service';
import { Router } from '@angular/router';
import { LoadingService } from '../../../../shared/loading/loading.service';
import { BrandingService } from '../../../../finish-pro/services/branding.service';
import { SignType } from '../../../../../app/models/types';
import { IvPadComponent } from '../../../../shared/components/iv-pad/iv-pad.component';
import { TranslateService } from '../../../../core/translation';
import { v4 as uuidv4 } from 'uuid';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';

@Component({
  selector: 'app-webSocketsignerPro',
  templateUrl: './webSocketsigner.component.html',
  styleUrls: ['./webSocketsigner.component.scss'],
  providers: [IvSignService, UserService],
})
export class WebSocketSignerProComponent implements AfterViewInit, OnDestroy {
  /**
   * IvPad component from ivpad librarie.
   */
  @ViewChild('ivpad') ivpad: IvPadComponent;

  /**
   * Event triggered after finish the signature.
   */
  @Output() afterSigned: EventEmitter<any[]> = new EventEmitter();

  /**
   * Event triggered when there's an error.
   */
  @Output() onError = new EventEmitter();

  callback: EventEmitter<any> = new EventEmitter();

  /**
   * String containing the IvSign token
   */
  token: string = null;

  /**
   * Array that contains the pdfs of the circuit.
   */
  pdfs: any[] = null;

  /**
   * Object for the sign widget
   */
  widget: any;

  /**
   * Boolean for set if the circuit has an afterview event
   */
  afterView = false;

  webSocket2: WebSocketSubject<any>;

  queryParams: string = '';

  /**
   * Verify if setting of pressure is active
   */
  verifyPressure: number;

  /**
   * The signature has been made
   */
  isSigFinish: boolean = false;

  labelSign: string = '';

  labelClean: string = '';

  _transParam: boolean = false;

  deviceAllowed: boolean = true;

  biometry: boolean = false;

  socketId: string = uuidv4();

  operationId: string = '';

  message = {
    Group: this.operationId,
    Id: this.socketId,
    Type: 3,
    SendToParent: null,
  }

  send = {
    Message: null,
    SubType: 0,
    Type: 3,
    WebSocketId: null,
  }

  webSocketURL: string = 'wss://sigsocketspro.apps.signa.run';

  constructor(
    private ref: ChangeDetectorRef,
    private _loading: LoadingService,
    public _router: Router,
    public _dialog: MatDialog,
    public _translate: TranslateService,
    public _branding: BrandingService) {
    this._branding.generateBranding();
  }

  ngAfterViewInit(): void {
    this.operationId = window.location.href.split('/')[4];
    this.validateWebSocket();
    this.webSocket2 = webSocket({
      url: `${this.webSocketURL}/ivcert?id=${this.socketId}&group=${this.operationId}&type=2`,
      closeObserver: {
        next: () => {
          const messageClose = this.message;
          const sendClose = this.send;
          messageClose.Type = 4;
          this.send.Message = messageClose;
          this.webSocket2.next(sendClose);
        }
      },
    })

    this.webSocket2.subscribe(response => {
      if (response.Message) {
        if (response.Type === 3) {
          this.afterSigned.emit(response.Message);
        }
      }
    })

    this._loading.set(true);
    this.ivpad.changeConfig({ autoDownload: false, showButtons: false });
    this.ivpad.disableErrors();
    this.ivpad.disableLoading();
    this.ivpad.signatureCanvas.setOptions('backgroundColor', 'rgba(0,0,0,0)');
    this.afterView = true;
    this.ref.detectChanges();
    this.queryParams = this._router.url.split('?id=')[1];
    if (navigator.maxTouchPoints <= 0) {
      this.deviceAllowed = false;
    }

    this.getTranslations();
  }

  ngOnDestroy(): void {
    this.webSocket2.complete();
  }

  validateWebSocket() {
    const url = window.location.href;

    if (url.includes('.qatest') || url.includes('.test')) {
      this.webSocketURL = 'wss://sigsocketspre.apps.signa.run';
    } else {
      this.webSocketURL = 'wss://sigsocketspro.apps.signa.run';
    }
  }

  getTranslations(): void {
    setTimeout(() => {
      this.labelSign = this._translate.instant('signaturit_pro.webSocket.sign');
      this.labelClean = this._translate.instant('signaturit_pro.webSocket.clean');
    }, 200);
  }

  /**
   * The function sets the data of the operation for sign
   * @param {any} data The data of the operation
   */
  setData(data: any): void {
    this.verifyPressure = data.verifyPressure;
    this.pdfs = data.pdfs;
    this.widget = data.widget;
    this.token = data.token;
  }

  /**
   * The function emits the error to the user
   * @param {any} error The error produced
   */
  emitError(error: any): void {
    this.onError.emit(error);
  }

  clearSign(): void {
    this.ivpad.clearSign();
  }

  sign(): void {
    const sig = this.ivpad.signatureCanvas.toDataURL('image/png').replace('data:image/png;base64,', '');
    const signOptions: SignType = { data: JSON.stringify(this.ivpad.data), sign: sig };
    if (!this.ivpad.checkSignature()) {
      this.isSigFinish = true;
      if (this.biometry) {
        this.message.SendToParent = this.deviceAllowed;
        this.send.Message = JSON.stringify(this.message);
        this.webSocket2.next(this.send);
      }
      this.message.SendToParent = signOptions;
      this.send.Message = JSON.stringify(this.message);
      this.webSocket2.next(this.send);
    }
  }
}
